export const SUPPORTED_MEETING_PROVIDERS = ['zoom', 'teams', 'meet', 'webex'] as const

export const MEETING_PROVIDERS = ['zoom', 'teams', 'meet', 'webex', 'phone', 'phone-ringcentral', 'phone-goto'] as const

export const PROVIDER_NAME_MAPPING: Record<string, string> = {
  meet: 'google_meets',
  teams: 'ms_teams',
  webex: 'webex',
}

export type MeetingProvider = (typeof MEETING_PROVIDERS)[number]
export type SupportedMeetingProvider = (typeof SUPPORTED_MEETING_PROVIDERS)[number]

export const getSupportedProviderFromAdhocMeetingLink = (meetingLink: string) => {
  try {
    const url = new URL(meetingLink)
    const host = url.host
    for (const provider of SUPPORTED_MEETING_PROVIDERS) {
      if (host.includes(provider)) {
        return provider
      }
    }
  } catch {
    return null
  }
}

export const isSupportedMeetingProvider = (provider: string): provider is SupportedMeetingProvider => {
  return SUPPORTED_MEETING_PROVIDERS.includes(provider as SupportedMeetingProvider)
}
